/**
 ShapeDiver 3D Viewer Application

 MaterialPropertiesGem.js

 Content:
   The definition for the gem material.

  Copyright (c) 2018 ShapeDiver GmbH

  @module MaterialPropertiesGem
 */

/**
 * Utility function to convert from all kinds of string formats to a tinycolor
 * @function
 * @ignore
 */
var toTinyColor = require('../util/toTinyColor');

/**
 * @typedef {Object} JSONGemMaterial
 * @version 1.0
 * @variation 1
 * @see module:JSONMaterial~JSONColor
 * @property {String} version - "1.0"

 * @see module:JSONMaterial~JSONColor
 * @property {Number} [opacity] the general opacity
 * @property {Number} [tracingOpacity] the opacity of the first probability when entering
 * @property {String|String[]} [environmentMap] the environment map for this material
 * @property {String|String[]} [impurityMap] the impurity map for this material
 * @property {Number} [impurityScale] the scale of the impurity
 * @property {module:JSONMaterial~JSONColor} [colorTransferBegin] the beginning color of the color transfer function that is interpolated by the tracing depth
 * @property {module:JSONMaterial~JSONColor} [colorTransferEnd] the end color of the color transfer function that is interpolated by the tracing depth
 * @property {Number} [depth] the tracing depth of the ray inside the stone
 * @property {Number} [resolution] the resolution of one cubemap face, must be power of two
 * @property {Number} [refractionIndex] the fraction index of the stone
 * @property {Number} [dispersion] the amount of dispersion
 * @property {Number} [gamma] the gamma of every color that is read out every step of the tracing process
 * @property {Number} [contrast] the contrast of every color that is read out every step of the tracing process
 * @property {Number} [brightness] the brightness of every color that is read out every step of the tracing process
 */

/**
 * 
 */
var MaterialPropertiesGem = function () {
  let that = this;
  that.materialType = 'gem';

  that.colorTransferBegin = toTinyColor('ffffffff').toThreeColor();
  that.colorTransferEnd = toTinyColor('ffffffff').toThreeColor();
  that.environmentMap = null;
  that.impurityMap = null;
  that.impurityScale = 1.0;
  that.opacity = 1.0;
  that.tracingOpacity = 1.0;
  that.depth = 8;
  that.refractionIndex = 2.4;
  that.dispersion = 0.0;
  that.gamma = 1.0;
  that.contrast = 1.0;
  that.brightness = 0.0;

  that.resolution = 1024;

  that.clone = function() {
    let m = new MaterialPropertiesGem();
    m.materialType = 'gem';

    m.colorTransferBegin = that.colorTransferBegin;
    m.colorTransferEnd = that.colorTransferEnd;
    m.environmentMap = that.environmentMap;
    m.impurityMap = that.impurityMap;
    m.impurityScale = that.impurityScale;
    m.opacity = that.opacity;
    m.tracingOpacity = that.tracingOpacity;
    m.depth = that.depth;
    m.refractionIndex = that.refractionIndex;
    m.dispersion = that.dispersion;
    m.gamma = that.gamma;
    m.contrast = that.contrast;
    m.brightness = that.brightness;
    m.resolution = that.resolution;

    return m;
  };
};

module.exports = MaterialPropertiesGem;
